exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-c4ccf04a] .el-dialog{max-width:100vw;max-height:100vh}.fill-screen[data-v-c4ccf04a] .el-dialog{margin:0 !important;padding:0;overflow:auto;width:100vw !important;height:100vh;left:0px;right:0px;top:0px;bottom:0px}.resize-center[data-v-c4ccf04a] .el-dialog{overflow:auto;width:fit-content;height:initial}\n", ""]);

// exports
